import { render, staticRenderFns } from "./DialogLegalAcceptance.vue?vue&type=template&id=11a23788&scoped=true&"
import script from "./DialogLegalAcceptance.vue?vue&type=script&lang=js&"
export * from "./DialogLegalAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./DialogLegalAcceptance.vue?vue&type=style&index=0&id=11a23788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a23788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a23788')) {
      api.createRecord('11a23788', component.options)
    } else {
      api.reload('11a23788', component.options)
    }
    module.hot.accept("./DialogLegalAcceptance.vue?vue&type=template&id=11a23788&scoped=true&", function () {
      api.rerender('11a23788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogLegalAcceptance.vue"
export default component.exports